import { useEffect, useState } from "react";
import axios from "axios";
import { FiMessageCircle } from "react-icons/fi";
import { getSession } from "../utils/session";
import ChatConversacion from "./ChatConversacion";
import { API_URL } from "../services/api";

// Lo que se le ofrece a quien abre el chat por primera vez y no sabe qué
// escribir. Una pantalla en blanco no se rellena sola.
const ARRANQUES = [
  "Tengo una duda con un ejercicio",
  "¿Puedo cambiar un día de entreno?",
  "No me cuadra una comida del plan",
  "Esta semana no voy a poder entrenar",
];

export default function TextChat() {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // Cargar historial y refrescarlo para ver las respuestas del entrenador
  // ponytail: sondeo cada 5 s; pasar a Socket.IO (ya está en el backend) si hace falta inmediatez
  useEffect(() => {
    let vivo = true;
    async function fetchMessages() {
      try {
        const { token } = await getSession();
        const res = await axios.get(`${API_URL}/chat`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (vivo) {
          setMessages(res.data);
          setError("");
        }
      } catch (err) {
        if (vivo) setError("No se pudo cargar el chat.");
      }
      if (vivo) setLoading(false);
    }
    fetchMessages();
    const id = setInterval(fetchMessages, 5000);
    return () => {
      vivo = false;
      clearInterval(id);
    };
  }, []);

  return (
    <div className="chat-box">
      <ChatConversacion
        messages={messages}
        mio="user"
        otro={{ nombre: "Titan" }}
        enviarUrl={`${API_URL}/chat`}
        placeholder="Escribe tu mensaje..."
        boton="Enviar"
        onCambio={setMessages}
      >
        {loading && <div className="app-estado">Cargando chat...</div>}
        {!loading && !error && messages.length === 0 && (
          <div className="chat-vacio">
            <FiMessageCircle aria-hidden="true" />
            <h3>Escribe a tu entrenador</h3>
            <p>
              Dudas con un ejercicio, un cambio de día, cómo te has encontrado hoy:
              lo que necesites. Te responde aquí mismo.
            </p>
            <ul>
              {ARRANQUES.map((a) => (
                <li key={a}>{a}</li>
              ))}
            </ul>
          </div>
        )}
        {error && <div className="app-estado app-estado-error">{error}</div>}
      </ChatConversacion>
    </div>
  );
}
